import React, { Component } from "react";
import { AuthDescription, AuthDetail, AuthStoreLinks, AuthSurface, AuthTitle } from "src/components";
import { SetupPasswordContainerContext } from "src/components/SetupPasswordContainerContext";
import DownloadApple from "src/img/Apple@2x.png";
import DownloadGoogle from "src/img/Google@2x.png";
import { getAppDetails } from "src/config/appVariants";

const storeLinkStyle = {
    width: "10rem",
    height: "3.25rem",
    flex: "0 0 10rem",
    overflow: "hidden"
};

const storeBadgeStyle = {
    width: "100%",
    minWidth: "100%",
    maxWidth: "none",
    height: "100%",
    objectFit: "fill"
};

const googleStoreBadgeStyle = {
    ...storeBadgeStyle,
    transform: "scale(1.14, 1.46)"
};

class WellDone extends Component {
    static contextType = SetupPasswordContainerContext;

    render() {
        const { businessName, accessCode, appVariant } = this.context;
        const app = getAppDetails(appVariant);
        return (
            <AuthSurface>
                <AuthTitle>Well Done!</AuthTitle>
                <AuthDescription>
                    You may now proceed to download the application and utilise your access code and password credentials to log in to {businessName} {app.displayName}.
                </AuthDescription>
                <AuthDescription>
                    Please ensure that you select &rsquo;Business Login&rsquo; option in order to gain access to the business application.
                </AuthDescription>
                <AuthDetail>Access Code: {accessCode}</AuthDetail>
                <AuthDescription>Download the app</AuthDescription>
                <AuthStoreLinks>
                    {app.appStoreUrl && <a href={app.appStoreUrl} target="_blank" rel="noopener noreferrer" style={storeLinkStyle}>
                        <img src={DownloadApple} alt="Download on the App Store" style={storeBadgeStyle} />
                    </a>}
                    {app.playStoreUrl && <a href={app.playStoreUrl} target="_blank" rel="noopener noreferrer" style={storeLinkStyle}>
                        <img src={DownloadGoogle} alt="Get it on Google Play" style={googleStoreBadgeStyle} />
                    </a>}
                </AuthStoreLinks>
            </AuthSurface>
        );
    }
}

export default WellDone;
